import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';

export interface DryEyeAssessmentFormControls {
  images: FormControl;
  impressions: FormControl;
  doctorNotes: FormControl;
  category: FormControl;
  recommendedPlanByDoctor: FormControl;
  recommendedEyeDrops: FormControl;
  recommendedRxEyeDrops: FormControl;
  recommendedExercises: FormControl;
  recommendedProcedures: FormControl;
  goalsForPatient: FormControl;
  treatmentPerformed: FormControl;
  mlPrediction: FormControl;
  aiScribeResult: FormControl;
}

export class DryEyeAssessmentFormGroup extends FormGroup {
  controls: DryEyeAssessmentFormControls & { [key: string]: AbstractControl };
  submitted = false;

  constructor() {
    super({
      impressions: new FormControl('', Validators.required),
      doctorNotes: new FormControl(''),
      category: new FormControl(''),
      images: new FormControl([]),
      recommendedPlanByDoctor: new FormControl('', Validators.required),
      recommendedEyeDrops: new FormControl([]),
      recommendedRxEyeDrops: new FormControl([]),
      recommendedExercises: new FormControl([]),
      recommendedProcedures: new FormControl([]),
      goalsForPatient: new FormControl(''),
      treatmentPerformed: new FormControl(''),
      mlPrediction: new FormControl(),
      aiScribeResult: new FormControl(null)
    });
  }
}
